export { default } from './InfoItem';
